import React from "react";
import { useState } from "react";
import { useTheme } from './theme/ThemeContext.jsx';
import mlbButton from "../Components/buttonImages/mlbButton.jpeg";
import nhlButton from "../Components/buttonImages/nhlButton.jpeg";
import footBallButton from "../Components/buttonImages/footBallButton.png"; 
import nbaButton from "../Components/buttonImages/nbalogo.jpeg";

function Button({ buttonData, onClickCallback }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="sport-picker__item"
      style={{ transform: isHovered ? "translateY(-3px) scale(1.03)" : "none" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onClickCallback(buttonData.text)}
    >
      <img
        className="sport-picker__image"
        src={buttonData.imageURL}
        alt={buttonData.text}
      />
    </div>
  );
}

function SportButtons({ buttonsData, onClickCallback }) {
  return (
    <div>
      <div className="sport-picker__grid">
        {buttonsData
          ? buttonsData.map((button, index) => (
              <Button
                key={index}
                buttonData={button}
                onClickCallback={onClickCallback}
              />
            ))
          : null}
      </div>
    </div>
  );
}

function AddSportButtons({ setSelectMatchesType }) {
  const sportButtons = [
    {
      text: "Hockey",
      imageURL:
       nhlButton
    },
    {
      text: "Football",
      imageURL:
        footBallButton
    },
    {
      text: "Baseball",
      imageURL:
        mlbButton
    },
    {
      text: "Basketball",
      imageURL:
        nbaButton
    },
  ];

  const { theme } = useTheme();

  return (
    <>
      <div className={`sport-picker sport-picker--${theme}`}>
        <div>
          {SportButtons({
            buttonsData: sportButtons,
            onClickCallback: setSelectMatchesType,
          })}
        </div>
      </div>
    </>
  );
}

export default AddSportButtons;